import { render, staticRenderFns } from "./PermissionAdmin.vue?vue&type=template&id=5e40ebc1&scoped=true"
import script from "./PermissionAdmin.vue?vue&type=script&lang=js"
export * from "./PermissionAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40ebc1",
  null
  
)

export default component.exports